import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';

/**
 * Eigener Bestand-Bereich (hl-area). Dünner Wrapper um den wiederverwendbaren
 * Konverter `bp-bestand-converter`, der auch im Vegetationsreiter eingebunden ist.
 */
@Component({
	standalone: false,
	selector: 'bp-bestand',
	templateUrl: './bestand.component.html',
	styleUrls: ['./hl-area.component.css'],
})
export class BestandComponent extends HlAreaComponent {}
